import { render, staticRenderFns } from "./ModalCrearGrupoDocumento.vue?vue&type=template&id=6d8bf23f&"
import script from "./ModalCrearGrupoDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalCrearGrupoDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports